import React from 'react';
import FluentIcon from '../components/FluentIcon';
import config from '../config';

const Help: React.FC = () => {
  return (
    <div>
      {/* Page Header */}
      
      {/* API Documentation Section */}
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
        border: '1px solid #e5e7eb',
        marginBottom: '24px'
      }}>
        <div style={{
          padding: '24px',
          borderBottom: '1px solid #e5e7eb'
        }}>
          <h2 style={{
            fontSize: '20px',
            fontWeight: '600',
            color: '#111827',
            margin: '0 0 8px 0',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <FluentIcon name="book" size={20} />
            API Documentation
          </h2>
          <p style={{
            fontSize: '14px',
            color: '#6b7280',
            margin: 0
          }}>
            Interactive API documentation with different viewing formats
          </p>
        </div>

        <div style={{
          padding: '24px'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '20px'
          }}>
            {/* Swagger UI */}
            <div style={{
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              padding: '20px',
              backgroundColor: '#fafafa'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                marginBottom: '12px'
              }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '8px',
                  background: 'linear-gradient(135deg, #85D1CE 0%, #4FB3D9 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <FluentIcon name="code" size={20} color="white" />
                </div>
                <div>
                  <h3 style={{
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#111827',
                    margin: '0 0 4px 0'
                  }}>
                    Swagger UI
                  </h3>
                  <p style={{
                    fontSize: '12px',
                    color: '#6b7280',
                    margin: 0
                  }}>
                    Interactive API Explorer
                  </p>
                </div>
              </div>

              <p style={{
                fontSize: '14px',
                color: '#374151',
                marginBottom: '16px',
                lineHeight: '1.5'
              }}>
                Interactive documentation where you can test API endpoints directly in your browser. 
                Perfect for exploring the API and making test requests.
              </p>

              <div style={{
                backgroundColor: 'white',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                padding: '12px',
                marginBottom: '16px'
              }}>
                <p style={{
                  fontSize: '12px',
                  color: '#6b7280',
                  margin: '0 0 4px 0',
                  fontWeight: '500'
                }}>
                  Features:
                </p>
                <ul style={{
                  fontSize: '12px',
                  color: '#374151',
                  margin: 0,
                  paddingLeft: '16px'
                }}>
                  <li>Try out API endpoints directly</li>
                  <li>See request/response examples</li>
                  <li>Built-in authentication testing</li>
                  <li>Parameter validation</li>
                </ul>
              </div>

              <a
                href={`${config.backendUrl}/docs`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '10px 16px',
                  backgroundColor: '#3b82f6',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '6px',
                  fontSize: '14px',
                  fontWeight: '500',
                  transition: 'background-color 0.2s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#2563eb'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#3b82f6'}
              >
                <FluentIcon name="open" size={16} />
                Open Swagger UI
              </a>
            </div>

            {/* ReDoc */}
            <div style={{
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              padding: '20px',
              backgroundColor: '#fafafa'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                marginBottom: '12px'
              }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '8px',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <FluentIcon name="document" size={20} color="white" />
                </div>
                <div>
                  <h3 style={{
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#111827',
                    margin: '0 0 4px 0'
                  }}>
                    ReDoc
                  </h3>
                  <p style={{
                    fontSize: '12px',
                    color: '#6b7280',
                    margin: 0
                  }}>
                    Beautiful API Reference
                  </p>
                </div>
              </div>

              <p style={{
                fontSize: '14px',
                color: '#374151',
                marginBottom: '16px',
                lineHeight: '1.5'
              }}>
                Clean, responsive documentation with a focus on readability. 
                Ideal for understanding API structure and integration planning.
              </p>

              <div style={{
                backgroundColor: 'white',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                padding: '12px',
                marginBottom: '16px'
              }}>
                <p style={{
                  fontSize: '12px',
                  color: '#6b7280',
                  margin: '0 0 4px 0',
                  fontWeight: '500'
                }}>
                  Features:
                </p>
                <ul style={{
                  fontSize: '12px',
                  color: '#374151',
                  margin: 0,
                  paddingLeft: '16px'
                }}>
                  <li>Clean, readable layout</li>
                  <li>Detailed schema documentation</li>
                  <li>Code examples in multiple languages</li>
                  <li>Responsive design</li>
                </ul>
              </div>

              <a
                href={`${config.backendUrl}/redoc`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '10px 16px',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '6px',
                  fontSize: '14px',
                  fontWeight: '500',
                  transition: 'opacity 0.2s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.opacity = '0.9'}
                onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
              >
                <FluentIcon name="open" size={16} />
                Open ReDoc
              </a>
            </div>
          </div>

          {/* Quick Comparison */}
          <div style={{
            marginTop: '24px',
            padding: '16px',
            backgroundColor: '#f8fafc',
            border: '1px solid #e2e8f0',
            borderRadius: '8px'
          }}>
            <h4 style={{
              fontSize: '14px',
              fontWeight: '600',
              color: '#374151',
              margin: '0 0 12px 0'
            }}>
              Quick Comparison:
            </h4>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
              gap: '16px',
              fontSize: '12px'
            }}>
              <div>
                <p style={{ margin: '0 0 4px 0', fontWeight: '500', color: '#1f2937' }}>
                  Use Swagger UI when:
                </p>
                <ul style={{ margin: 0, paddingLeft: '16px', color: '#6b7280' }}>
                  <li>Testing API endpoints</li>
                  <li>Debugging requests</li>
                  <li>Learning API behavior</li>
                </ul>
              </div>
              <div>
                <p style={{ margin: '0 0 4px 0', fontWeight: '500', color: '#1f2937' }}>
                  Use ReDoc when:
                </p>
                <ul style={{ margin: 0, paddingLeft: '16px', color: '#6b7280' }}>
                  <li>Reading comprehensive docs</li>
                  <li>Understanding data models</li>
                  <li>Integration planning</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Quick Start Guide */}
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
        border: '1px solid #e5e7eb',
        marginBottom: '24px'
      }}>
        <div style={{
          padding: '24px',
          borderBottom: '1px solid #e5e7eb'
        }}>
          <h2 style={{
            fontSize: '20px',
            fontWeight: '600',
            color: '#111827',
            margin: '0 0 8px 0',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <FluentIcon name="rocket" size={20} />
            Quick Start Guide
          </h2>
          <p style={{
            fontSize: '14px',
            color: '#6b7280',
            margin: 0
          }}>
            Get started with the WHOIS API in minutes
          </p>
        </div>

        <div style={{
          padding: '24px'
        }}>
          <div style={{
            display: 'grid',
            gap: '16px'
          }}>
            <div style={{
              display: 'flex',
              gap: '12px'
            }}>
              <div style={{
                width: '24px',
                height: '24px',
                borderRadius: '50%',
                backgroundColor: '#3b82f6',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px',
                fontWeight: '600',
                flexShrink: 0
              }}>
                1
              </div>
              <div>
                <h4 style={{
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#111827',
                  margin: '0 0 4px 0'
                }}>
                  Get an API Token
                </h4>
                <p style={{
                  fontSize: '13px',
                  color: '#6b7280',
                  margin: 0
                }}>
                  Visit the <a href="/tokens" style={{ color: '#3b82f6', textDecoration: 'none' }}>API Tokens</a> page to create your first API token.
                </p>
              </div>
            </div>

            <div style={{
              display: 'flex',
              gap: '12px'
            }}>
              <div style={{
                width: '24px',
                height: '24px',
                borderRadius: '50%',
                backgroundColor: '#3b82f6',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px',
                fontWeight: '600',
                flexShrink: 0
              }}>
                2
              </div>
              <div>
                <h4 style={{
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#111827',
                  margin: '0 0 4px 0'
                }}>
                  Test the API
                </h4>
                <p style={{
                  fontSize: '13px',
                  color: '#6b7280',
                  margin: 0
                }}>
                  Use the <a href="/testing" style={{ color: '#3b82f6', textDecoration: 'none' }}>API Testing</a> page to test domain lookups with your token.
                </p>
              </div>
            </div>

            <div style={{
              display: 'flex',
              gap: '12px'
            }}>
              <div style={{
                width: '24px',
                height: '24px',
                borderRadius: '50%',
                backgroundColor: '#3b82f6',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px',
                fontWeight: '600',
                flexShrink: 0
              }}>
                3
              </div>
              <div>
                <h4 style={{
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#111827',
                  margin: '0 0 4px 0'
                }}>
                  Integrate
                </h4>
                <p style={{
                  fontSize: '13px',
                  color: '#6b7280',
                  margin: 0
                }}>
                  Use the documentation above to integrate the API into your application.
                </p>
              </div>
            </div>
          </div>

          {/* Example Code */}
          <div style={{
            marginTop: '20px',
            padding: '16px',
            backgroundColor: '#1f2937',
            borderRadius: '8px',
            color: '#f9fafb',
            fontFamily: 'monospace',
            fontSize: '13px',
            overflow: 'auto'
          }}>
            <div style={{ marginBottom: '8px', color: '#9ca3af' }}>
              # Example API call
            </div>
            <div>
              curl -H "Authorization: Bearer YOUR_TOKEN" \<br />
              &nbsp;&nbsp;&nbsp;&nbsp; {config.apiUrl}/whois/google.com
            </div>
          </div>
        </div>
      </div>

      {/* Support Section */}
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
        border: '1px solid #e5e7eb'
      }}>
        <div style={{
          padding: '24px',
          borderBottom: '1px solid #e5e7eb'
        }}>
          <h2 style={{
            fontSize: '20px',
            fontWeight: '600',
            color: '#111827',
            margin: '0 0 8px 0',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <FluentIcon name="question-circle" size={20} />
            Support & Resources
          </h2>
          <p style={{
            fontSize: '14px',
            color: '#6b7280',
            margin: 0
          }}>
            Additional resources and support information
          </p>
        </div>

        <div style={{
          padding: '24px'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '20px'
          }}>
            <div>
              <h4 style={{
                fontSize: '14px',
                fontWeight: '600',
                color: '#111827',
                margin: '0 0 8px 0'
              }}>
                System Status
              </h4>
              <p style={{
                fontSize: '13px',
                color: '#6b7280',
                marginBottom: '8px'
              }}>
                Check the current status of all services
              </p>
              <a
                href="/health"
                style={{
                  color: '#3b82f6',
                  textDecoration: 'none',
                  fontSize: '13px',
                  fontWeight: '500'
                }}
              >
                View Health Check →
              </a>
            </div>

            <div>
              <h4 style={{
                fontSize: '14px',
                fontWeight: '600',
                color: '#111827',
                margin: '0 0 8px 0'
              }}>
                Supported TLDs
              </h4>
              <p style={{
                fontSize: '13px',
                color: '#6b7280',
                marginBottom: '8px'
              }}>
                View all supported domain extensions
              </p>
              <a
                href="/tlds"
                style={{
                  color: '#3b82f6',
                  textDecoration: 'none',
                  fontSize: '13px',
                  fontWeight: '500'
                }}
              >
                View TLD List →
              </a>
            </div>

            <div>
              <h4 style={{
                fontSize: '14px',
                fontWeight: '600',
                color: '#111827',
                margin: '0 0 8px 0'
              }}>
                Rate Limits
              </h4>
              <p style={{
                fontSize: '13px',
                color: '#6b7280',
                marginBottom: '8px'
              }}>
                Understand API rate limiting and usage
              </p>
              <a
                href="/tokens"
                style={{
                  color: '#3b82f6',
                  textDecoration: 'none',
                  fontSize: '13px',
                  fontWeight: '500'
                }}
              >
                Manage Tokens →
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Help; 